import NeighborhoodGuideHeroCard from '../NeighborhoodGuideHeroCard/NeighborhoodGuideHeroCard';
import './NeighborhoodGuideHeroSection.scss';
import { NeighborhoodGuideHeroSectionProps } from './NeighborhoodGuideHeroSection.types';
import { useEffect, useState } from 'react';
import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from '../../../../sanity.io/config';

const NeighborhoodGuideHeroSection = ({ neighborhood, quintessentialExperience, heroImageUrl }: NeighborhoodGuideHeroSectionProps) => {
  const [img, setImg] = useState('');

  useEffect(() => {
    if (heroImageUrl) {
      setImg(heroImageUrl.split('image-')[1].replace('-jpg', '.jpg'));
    }
  }, [heroImageUrl]);
  return (
    <div className="neighborhood-guide">
      <section className="banner-section">
        <div className="banner-text">AN URBAIN GUIDE TO {neighborhood}</div>
      </section>
      <section
        className="hero-section d-flex flex-column position-relative"
        style={{ background: `url(${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/${img}) center center / cover` }}
      >
        <NeighborhoodGuideHeroCard
          neighborhood={neighborhood}
          quintessentialExperience={quintessentialExperience}
          innerClassName={'d-none d-xl-block col-6'}
        />
      </section>
      <NeighborhoodGuideHeroCard
        neighborhood={neighborhood}
        quintessentialExperience={quintessentialExperience}
        innerClassName={'d-block d-xl-none col-12'}
      />
    </div>
  );
};

export default NeighborhoodGuideHeroSection;
